import { UsersList } from "@/components/audiolab/admin/UsersList";
import ContainerWrapper from "@/components/ui/ContainerWrapper";
import { Button, Flex, Text } from "@radix-ui/themes";
import { createFileRoute, Link } from "@tanstack/react-router";

function UsersPage() {
  return (
    <ContainerWrapper className="py-8">
      <Flex direction="column" gap="6">
        <Flex justify="between" align="center">
          <Flex direction="column" gap="2">
            <Text size="8" weight="bold">
              Users
            </Text>
            <Text size="4" color="gray">
              Browse users and see the creators each one is the main contact
              for.
            </Text>
          </Flex>
          <Button asChild variant="soft" color="gray">
            <Link to="/admin">Back to admin</Link>
          </Button>
        </Flex>

        <UsersList />
      </Flex>
    </ContainerWrapper>
  );
}

export const Route = createFileRoute("/admin/_adminLayout/users")({
  component: UsersPage,
});
